import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';
import { DrawerFormDataType } from '@/types';

import { useBatchFeaturedPeople } from '../api/batch-featured-people';
import { useDeleteFeaturedPeople } from '../api/delete-featured-people';
import { TFeaturedPeopleType } from '../types';

type TFeaturedPeopleControllersReturn = {
  featuredPeopleDialog: ReturnType<typeof useDisclosureWithData<TFeaturedPeopleType>>;
  featuredPeopleDrawer: ReturnType<
    typeof useDisclosureWithData<DrawerFormDataType<TFeaturedPeopleType>>
  >;
  handleDeleteFeaturedPeople: () => void;
  multiFeaturedPeopleDialog: ReturnType<typeof useDisclosureWithData<TFeaturedPeopleType[]>>;
  handleDeleteMultipleFeaturedPeople: () => void;
};

export function useFeaturedPeopleControllers(): TFeaturedPeopleControllersReturn {
  const featuredPeopleDialog = useDisclosureWithData<TFeaturedPeopleType>();
  const featuredPeopleDrawer = useDisclosureWithData<DrawerFormDataType<TFeaturedPeopleType>>();
  const { mutate: deleteFeaturedPeople } = useDeleteFeaturedPeople();

  const multiFeaturedPeopleDialog = useDisclosureWithData<TFeaturedPeopleType[]>();
  const { mutate: deleteMultipleFeaturedPeople } = useBatchFeaturedPeople();

  const handleDeleteFeaturedPeople = () => {
    if (featuredPeopleDialog.data) {
      deleteFeaturedPeople(
        {
          id: featuredPeopleDialog.data.id,
        },
        {
          onSuccess: () => {
            featuredPeopleDialog.close();
          },
        }
      );
    }
  };

  const handleDeleteMultipleFeaturedPeople = () => {
    if (multiFeaturedPeopleDialog.data) {
      deleteMultipleFeaturedPeople(
        {
          action: 'delete',
          items: multiFeaturedPeopleDialog.data.map(person => ({ id: person.id })),
        },
        {
          onSuccess: () => {
            multiFeaturedPeopleDialog.close();
          },
        }
      );
    }
  };

  return {
    featuredPeopleDialog,
    featuredPeopleDrawer,
    handleDeleteFeaturedPeople,
    multiFeaturedPeopleDialog,
    handleDeleteMultipleFeaturedPeople,
  };
}
